import type { SelectItem } from '@vrplatform/components';
import { useMemo } from 'react';
import {
  STORYBOOK_ACCOUNTS_QUERY_KEY,
  useAccountsQuery,
} from '@vrplatform/data';
import { getReservationLineTypeAccountOptions } from './useReservationLineTypeAccountOptionsQuery.utils';

type Props = {
  skip?: boolean;
};

export const STORYBOOK_RESERVATION_LINE_TYPE_ACCOUNT_OPTIONS_QUERY_KEY =
  STORYBOOK_ACCOUNTS_QUERY_KEY;

export const useReservationLineTypeAccountOptionsQuery = (args?: Props) => {
  const queryData = useAccountsQuery({
    skip: args?.skip,
    storybookQueryKey:
      STORYBOOK_RESERVATION_LINE_TYPE_ACCOUNT_OPTIONS_QUERY_KEY,
  });

  const data = useMemo<SelectItem[] | undefined>(
    () =>
      queryData.data
        ? getReservationLineTypeAccountOptions(queryData.data)
        : undefined,
    [queryData.data]
  );

  return {
    ...queryData,
    data,
  };
};
